module.exports = __webpack_public_path__ + "static/media/india_map.3a81d477.png";